import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "naa-overlay"
}
const _hoisted_2 = {
  class: "naa-box",
  role: "alertdialog",
  "aria-live": "assertive",
  "aria-label": "Novo atendimento atribuído"
}
const _hoisted_3 = { class: "naa-desc" }

import { computed } from 'vue'
import { pendingAssignments, dismissCurrentAssignmentAlert } from '@/composables/useAssignmentAlert'
import { requestOpenChat } from '@/composables/useChatTrigger'

// Só o primeiro da fila fica visível — os demais aparecem um a um, conforme
// o agente for dispensando (igual fila de toast, mas bloqueante).

export default /*@__PURE__*/_defineComponent({
  __name: 'AssignmentAlertModal',
  setup(__props) {

const current = computed(() => pendingAssignments.value[0] ?? null)

function handleStart() {
  if (!current.value) return
  requestOpenChat(current.value.convId)
  dismissCurrentAssignmentAlert()
}

/** Fecha o popup (e para o call.mp3, via dismissCurrentAssignmentAlert) sem abrir a conversa. */
function handleDismiss() {
  if (!current.value) return
  dismissCurrentAssignmentAlert()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "naa-fade" }, {
      default: _withCtx(() => [
        (current.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "naa-icon" }, "🎧", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "naa-title" }, "Novo atendimento atribuído", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Um novo atendimento foi atribuído a você", -1)),
                  (current.value.contactName)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[0] || (_cache[0] = _createTextVNode(" — ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(current.value.contactName), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _cache[2] || (_cache[2] = _createTextVNode(". ", -1))
                ]),
                _createElementVNode("div", { class: "naa-actions" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "naa-btn naa-btn--primary",
                    onClick: handleStart
                  }, " Iniciar atendimento "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "naa-btn naa-btn--secondary",
                    onClick: handleDismiss
                  }, " Dispensar ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})